import { BaseEntity } from 'yt-ng-framework';

export class CompanyRegister extends BaseEntity {
    Naziv: string = null;
    TipKomitentaID: number = null;
    Pib: string = null;
    MaticniBroj: string = null;
    Adresa: string = null;
    MestoID: number = null;
    Jmbg: string = null;
    BrojPoljoprivrednogGazdinstva: string = null;

    Deserialize(input: any) {
        this.Naziv = input.Naziv;
        this.Pib = input.Pib;
        this.MaticniBroj = input.MaticniBroj;
        this.Adresa = input.Adresa;
        this.MestoID = input.MestoID;

        return this;
    }

    Serialize(input: CompanyRegister) {
        return input;
    }
}